export default __webpack_public_path__ + "static/media/hyperledger-besu.7333da83.svg";